"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hw_app_cosmos_1 = __importDefault(require("@ledgerhq/hw-app-cosmos"));
const chain_1 = __importDefault(require("./chain/chain"));
const resolver = (transport, { path, verify, currency }) => __awaiter(void 0, void 0, void 0, function* () {
    const cosmosApiImpl = (0, chain_1.default)(currency.id);
    const cosmos = new hw_app_cosmos_1.default(transport);
    const r = yield cosmos.getAddress(path, cosmosApiImpl.prefix, verify || false);
    return {
        address: r.address,
        publicKey: r.publicKey,
        path,
    };
});
exports.default = resolver;
//# sourceMappingURL=hw-getAddress.js.map